import { get } from 'lodash-es';
import { $MTS } from '@mts-fe/utils';
import { inMtsApp } from '@mts/utils';

type PrintData = Recordable | Recordable[];
type getDataValue = (options: Recordable, data: Recordable) => string;

export const useHiPrint = async (template: Recordable) => {
  let data: PrintData;
  let instance;

  const { hiprint, hiPrintPlugin } = await import('vue-plugin-hiprint');
  const init = () => {
    hiPrintPlugin.disAutoConnect();
    hiprint.init();
    // https://www.npmjs.com/package/vue-plugin-hiprint
    instance = new hiprint.PrintTemplate({ template });
  };

  const setData = (printData: PrintData) => {
    data = printData;
  };

  const getDataTemplate = (getDataValue?: getDataValue) => {
    const templatePanels = instance.getJson().panels;
    templatePanels.length > 1 && console.warn('打印模版panels存在多个？', templatePanels);

    const panels: Recordable[] = [];
    const { printElements, ...restPanel } = templatePanels[0] || {};
    (Array.isArray(data) ? data : [data]).forEach((item) => {
      panels.push({
        ...restPanel,
        printElements: printElements.map(({ options, ...rest }) => {
          if (options.field) {
            const dataValue = getDataValue?.(options, item) || get(item, options.field);
            if (rest.printElementType.type === 'table') {
              return { ...rest, options: { ...options, rowData: dataValue || [] } };
            }
            return { ...rest, options: { ...options, testData: dataValue || '' } };
          }
          return { ...rest, options };
        }),
      });
    });
    return { panels };
  };

  const print = (
    printData?: PrintData,
    options: {
      getDataValue?: getDataValue;
      onSuccess?: (data: { r: number; data: string }) => void;
      [key: string]: any;
    } = {},
  ) => {
    if (!instance) return;

    printData && setData(printData);
    if (inMtsApp) {
      return $MTS.App.print({
        cb: (data) => {
          console.log('打印执行完成！');
          options.onSuccess?.(data);
        },
        data: JSON.stringify(getDataTemplate(options.getDataValue)),
      });
    }
    instance.print(data, {
      callback: () => console.log('浏览器打印窗口已打开'),
      ...options,
    });
  };

  const getHtml = () => {
    if (!instance) return;
    return instance.getHtml(data);
  };

  const printByHtml = (html) => {
    if (!instance) return;
    instance.printByHtml(html);
  };

  init();
  return { hiprint, instance, setData, print, getHtml, printByHtml };
};
